import payslipTemplate from '@/api/hr/payslip-template'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  userVariables: [],
  blocks: [],
  subBlocks: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_VARIABLE(state, variable) {
    state.userVariables = variable
  },
  SET_BLOCKS(state, data) {
    state.blocks = data.blocks
    state.subBlocks = data.subBlocks
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )
    return payslipTemplate.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return payslipTemplate.store(data)
  },

  destroy(context, id) {
    return payslipTemplate.destroy(id)
  },

  update(context, { id, data }) {
    return payslipTemplate.update(id, data)
  },

  async variable(context) {
    if (!context.state.userVariables.length > 0) {
      let response = await payslipTemplate.variable()
      context.commit('SET_VARIABLE', response.data)
      return Promise.resolve(response.data)
    }
  },
  async getBlock(context) {
    if (!context.state.blocks.length > 0) {
      let response = await payslipTemplate.block()
      context.commit('SET_BLOCKS', response.data)
      return Promise.resolve(response.data)
    }
  }
}
